import React from 'react';
import { Box, Card } from '@mui/material';
import NoItemsCreated from 'components/NoItemsCreated/NoItemsCreated';
import NoSearchFound from 'components/NoSearchFound/NoSearchFound';
import HeaderTilteBar from 'components/TitleBar/HeaderTilteBar';
import MainContainer from 'theme/MainConatiner';
import CommonDataGrid from 'components/TableListing/CommonTable';

const CustomersContainer = ({
  columns,
  rows,
  totalCount,
  loading,
  searchQuery,
  setSearchQuery,
  paginationModel,
  setPaginationModel,
  error
}) => {
  const isSearching = searchQuery.trim().length > 0;
  const hasData = !loading && rows.length > 0;
  const showNoItems = !loading && rows.length === 0 && !error;

  return (
    <MainContainer>
      <Card className="main-card-container" sx={{ padding: '0px !important' }}>
        <HeaderTilteBar
          title="Customers"
          isSearch={rows.length > 0 || isSearching}
          isAddVisible={false}
          btnText="Add New"
          btnIcon={false}
          onSearchChange={setSearchQuery}
          searchQuery={searchQuery}
          // padding={"16px 15px 8px 15px"}
        />

        {showNoItems ? (
          <Box className="body-wrapper">
            {isSearching ? (
              <NoSearchFound
                title="No customers match your search"
                subtitle="Please try again with a different keyword."
              />
            ) : (
              <NoItemsCreated title="No Customer Created Yet!" />
            )}
          </Box>
        ) : (
          <Box>
            <CommonDataGrid
              columns={columns}
              rows={rows}
              rowCount={totalCount}
              loading={loading}
              paginationModel={paginationModel}
              setPaginationModel={setPaginationModel}
            />
          </Box>
        )}
      </Card>
    </MainContainer>
  );
};

export default CustomersContainer;
